import { cva, VariantProps } from 'class-variance-authority'
import { HTMLAttributes, Ref } from 'react'

import { cn } from '@/shared/lib'

const messageVariants = cva('typo-caption1', {
  variants: {
    type: {
      default: 'text-gray-600',
      error: 'text-red-500',
    },
  },
})

export type Props = HTMLAttributes<HTMLParagraphElement> &
  VariantProps<typeof messageVariants> & {
    ref?: Ref<HTMLParagraphElement>
  }

export const Message = ({ type = 'default', className, ...props }: Props) => {
  return (
    <p className={cn(messageVariants({ type, className }))} {...props}>
      {props.children}
    </p>
  )
}
